<template>
<v-container v-show="showKT" grid-list-xs text-xs-center :class="[$style.widgetContainer, {'px-12':$vuetify.breakpoint.smAndUp}]">
    <v-layout row wrap justify-center :class="[{'px-12':$vuetify.breakpoint.smAndUp}]">
        <v-card elevation='3' shaped color="blue lighten-4" style="box-shadow:6px 6px #cccccc !important">
            <div :class="$style.widgetContainerMain">
                <div :class="$style.widgetContainerTitle">

                    <div :class="$style.widgetContainerTitleIconWrapper">
                        <div :class="$style.widgetContainerTitleIcon">
                            <v-icon color="#0090c1">
                                fas fa-book-open
                            </v-icon>
                        </div>
                    </div>  
                    <p>
                        {{label[language].title}}
                    </p>
                </div>
                <div>
                    <svg_icon :src="triangle" :class="['hidden-sm-and-down',$style.triangle]"/>
                </div>
            </div>

            <v-card-text v-html="label[ktIdentifier][language].parag_1"></v-card-text>
            <v-card-text class="pt-0" v-html="label[ktIdentifier][language].parag_2"></v-card-text>

            <v-card-text>
                <ol :class="$style.referenceList">
                    <li v-for="(listItem, index) in label[ktIdentifier][language].reference" :key='index' v-html="listItem"></li>
                </ol>
            </v-card-text>

            <v-card-actions class="justify-center">
                <v-btn color=#0090C1 @click="showKT=false">
                    <str style="color:white;" index="button > dismiss" />
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</v-container>
</template>

<script>
import labels from './KTID_LanguageLabels.js';
import svg_icon from '@/components/svg/svg_icon.vue';
import triangle from '../../assets/triangle.svg';

export default {
    name: "KTID_5",
    props: {
        displayWidget: {
            type: Boolean,
            default: false
        }
    },
    components: {
        svg_icon
    },
    created: function(){
        this.showKT = this.displayWidget;
    },
    data: function(){
        return {
            label: labels,
            showKT: false,
            ktIdentifier: "ktid_5"
        }
    },
    computed: {
        language: function(){
            return this.$store.getters.language;
        },
        triangle: function(){
            return triangle;
        },
        library: function(){
            return this.$store.getters.library ? this.$store.getters.library : false;
        }        
    }
}
</script>

<style module>
.widgetContainer {
    /* max-width: 600px; */
    /* border: 1px solid #bebebe; */
    /* background-color: white; */
    margin-top: -55px;
}

.widgetContainerMain {
    background-color:  #0090c1;
    width: 100%;
    height: 100px;
    color: white;
    text-align: center;
    margin-bottom: 3%;
}

.widgetContainerTitle {
    height: 100%;
    display: table;
    margin: 0 auto;
}

.widgetContainerTitleIconWrapper {
    display:table-cell;
    vertical-align: middle;
}

.widgetContainerTitleIcon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid white;
    background-color: white;
    position: relative;
}

.widgetContainer i {
    position: absolute;
    top: 25%;
    transform: translateY(-25%);
    left: 50%;
    transform: translateX(-50%);
}

.widgetContainerTitle p {
    display:table-cell;
    vertical-align: middle;
    font-size: 40px;
    color: white;
    font-weight: 300;
    padding-left: 10px;
}

.triangle{
    position: relative;
    bottom: 30px;
}
.triangle path{
    fill:   #0090c1 !important;
    stroke: none !important;
}

.referenceList {
    background-color: #e5f4f9;
    padding: 20px 0;
    font-style:italic;
    line-height: 1.6;
    color: #8c8b8b;
}

.referenceList li {
    margin-left: 20px;
    margin-bottom: 20px;
    width: 95%;

}

</style>

<style>

</style>